import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

export type AlertType = 'info' | 'success' | 'warning' | 'danger';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-alert',
  styleUrl: './alert.scss',
  templateUrl: './alert.html',
})
export class AlertComponent {
  /** Type d'alerte (couleur + icône). */
  readonly type = input<AlertType>('info');

  /** Titre optionnel de l'alerte. */
  readonly title = input('');

  /** Affiche un bouton de fermeture. */
  readonly dismissible = input(false);

  /** Émis lorsque l'utilisateur ferme l'alerte. */
  readonly dismissed = output<void>();

  protected readonly visible = signal(true);

  protected dismiss(): void {
    this.visible.set(false);
    this.dismissed.emit();
  }
}
